const hasText = (value) => typeof value === "string" && value.trim().length > 0;

const findMissionSection = (mission, title) =>
  Array.isArray(mission)
    ? mission.find((item) => (item?.title ?? "").trim() === title)
    : null;

export const DEFAULT_MISSION_TITLES = new Set([
  "캠페인 안내",
  "해시태그",
  "계정태그",
  "키워드",
]);

export const splitMissionText = (text) => {
  if (!hasText(text)) return [];

  return text
    .split(/[,，、\n]+/)
    .map((item) => item.trim())
    .filter(Boolean);
};

export const buildMissionPayload = (values = {}) => {
  const mission = [];

  if (hasText(values.mission_guide)) {
    mission.push({
      title: "캠페인 안내",
      desc: values.mission_guide.trim(),
    });
  }

  if (Array.isArray(values.mission_hashtags)) {
    const hashtags = values.mission_hashtags;
    if (hashtags.length > 0) {
      mission.push({
        title: "해시태그",
        desc: hashtags.join(", "),
      });
    }
  }

  if (Array.isArray(values.mission_account_tags)) {
    const accountTags = values.mission_account_tags;
    if (accountTags.length > 0) {
      mission.push({
        title: "계정태그",
        desc: accountTags.join(", "),
      });
    }
  }

  if (Array.isArray(values.mission_keywords)) {
    const keywords = values.mission_keywords;
    if (keywords.length > 0) {
      mission.push({
        title: "키워드",
        desc: keywords.join(", "),
      });
    }
  }

  if (Array.isArray(values.mission_custom_sections)) {
    values.mission_custom_sections.forEach((section) => {
      if (!hasText(section?.title) || !hasText(section?.desc)) return;

      mission.push({
        title: section.title.trim(),
        desc: section.desc.trim(),
      });
    });
  }

  return mission;
};

export const parseMissionPayload = (mission) => {
  const guideSection = findMissionSection(mission, "캠페인 안내");
  const hashtagSection = findMissionSection(mission, "해시태그");
  const accountTagSection = findMissionSection(mission, "계정태그");
  const keywordSection = findMissionSection(mission, "키워드");
  const customSections = Array.isArray(mission)
    ? mission
        .filter(
          (section) => !DEFAULT_MISSION_TITLES.has(section?.title?.trim())
        )
        .map((section) => ({
          title: section?.title ?? "",
          desc: section?.desc ?? "",
        }))
    : [];

  return {
    mission_guide: guideSection?.desc ?? "",
    mission_hashtags: splitMissionText(hashtagSection?.desc),
    mission_account_tags: splitMissionText(accountTagSection?.desc),
    mission_keywords: splitMissionText(keywordSection?.desc),
    mission_custom_sections: customSections,
  };
};

export const isMissionFormFilled = (values = {}) =>
  hasText(values.mission_guide);
